import { useCallback, useState } from 'react'
import { ClientKnownAddressModal } from './ClientKnownAddressModal'

import { ColourButton } from 'portal/lib/primitives'

export type ClientAddressName =
  | 'Delivery'
  | 'Dispatch'
  | 'Origin Site'
  | 'Facility Site'

export type KnownAddressResult = {
  entered: string
  known: string
  coordinates: { lat: number; lon: number }
}

export function ClientKnownAddressModalLink({
  addressName,
  hasValue,
  onSubmit
}: {
  addressName: ClientAddressName
  hasValue: boolean
  onSubmit: (result: KnownAddressResult) => void
}) {
  const [knownAddressModalOpen, setKnownAddressModalOpen] =
    useState<boolean>(false)

  const handleSubmit = useCallback(
    (result: KnownAddressResult) => {
      onSubmit(result)
      setKnownAddressModalOpen(false)
    },
    [onSubmit]
  )

  return (
    <>
      {hasValue && (
        <ColourButton.Basic
          style={{
            maxHeight: '2.5rem'
          }}
          type="button"
          aria-label={`Edit Known ${addressName} Address`}
          onClick={() => setKnownAddressModalOpen(true)}
          tabIndex={-1}
        >
          Edit address
        </ColourButton.Basic>
      )}
      {!hasValue && (
        <ColourButton.Action
          style={{ maxHeight: '2.5rem' }}
          type="button"
          aria-label={`Add Known ${addressName} Address`}
          onClick={() => setKnownAddressModalOpen(true)}
          tabIndex={-1}
        >
          Add address
        </ColourButton.Action>
      )}

      {knownAddressModalOpen && (
        <ClientKnownAddressModal
          addressName={addressName}
          isOpen={true}
          onCancel={() => setKnownAddressModalOpen(false)}
          onSubmit={handleSubmit}
        />
      )}
    </>
  )
}
